export default __webpack_public_path__ + "locales/pt/DowngradePlanDialog.json?hash=61941b3b31f04a85ea2ce5e4bfd4c3e8";